import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DottedBackground = styled(Stack)(() => ({
  "--dot-color": "rgba(50, 50, 50, 0.5)",
  "--dot-spacing": "11px",
  "--dot-size": "1px",

  backgroundImage:
    "radial-gradient(circle, var(--dot-color) var(--dot-size), transparent var(--dot-size))",
  backgroundPosition:
    "calc(var(--dot-spacing) / 2) calc(var(--dot-spacing) / 2)",
  backgroundSize: "var(--dot-spacing) var(--dot-spacing)",
}));
